module.exports = __webpack_public_path__ + "assets/img/4.c6f00436.png";